import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { loginOTP } from '../services/user';
import ReactCodeInput from 'react-verification-code-input';

const LoginOTP = (props) => {
  const [auth, setAuth] = useState(props.auth);
  const [error, setError] = useState(false);
  const [code, setCode] = useState('');
  const [referrer, setReferrer] = useState(null);
  const path = props.location.search.substr(6);

  useEffect(() => {
    document.title = 'EQS CLUB - Ingresá a tu cuenta';
  }, []);

  useEffect(() => {
    // Get referrer
    if (!props.location.search || props.location.search === '') {
      return;
    }

    const params = props.location.search.replaceAll('?', '&').split('&');
    params.forEach(item => {
      const a = item.split('=');
      if (a[0] === 'ref') {
        setReferrer(a[1]);
      }
    });

  }, [props.location.search]);

  useEffect(() => {
    if (auth) {
      if (path) {
        props.history.push(path);
      } else {
        props.history.push('/');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth])

  useEffect(() => {
    if (code.length === 6) {
      handleSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  const handleSubmit = async () => {
    if (!code || code.length !== 6) {
      return setError('Por favor, ingresá el código recibido.');
    }

    try {
      const res = await loginOTP(code, props.location.state?.email);
      if (!res.success) {
        throw new Error(res.error || 'Error al iniciar sesión con OTP');
      }
      if (res.token) {
        setAuth(true);
      }
    } catch (e) {
      return setError('Error al iniciar sesión con OTP');
    }
  };

  return (
    <div className="signup-template">
      <div className="row g-0 align-items-center">
        <div className="col-lg-7 bg-black">
          {
            props.assets.signin_cover_web && <img src={props.assets.signin_cover_web} className="cover-fit" alt="Sign in Cover" />
          }
        </div>
        <div className="col-lg-5 px-md-3 px-xl-5">
          <div className="px-3 py-4 p-md-5 p-xxl-5 mx-xxl-4">
            <div className="login-form py-2 py-md-0 mx-auto mx-lg-0">
              <h2 className="h1 mb-3">Código de verificación</h2>
              <p className="mt-4 mb-0">Ingresá el código que te enviamos al email:</p>
              <p className="mb-4 fw-bold">{props.location.state?.email}</p>
              <div className="mt-5 justify-content-center d-flex flex-column align-items-center">
                <ReactCodeInput
                  type="number"
                  fields={6}
                  autoFocus={true}
                  value={code}
                  onChange={setCode}
                />
                <p className="text-danger fw-bold">{error}</p>
              </div>
              <div className="d-grid">
                <div className="border-top border-gray-200 my-5 text-center text-decoration-underline">
                  <a
                    href={"mailto:" + process.env.REACT_APP_SUPPORT_EMAIL}
                    className="text-gray-700"
                    style={{ cursor: 'pointer' }}>No recibí el código</a>
                </div>
              </div>
              <div className="d-grid">
                <button onClick={handleSubmit} className="btn btn-xl btn-primary">Ingresar con código</button>
              </div>
              <NavLink to="/solicitar-otp" className="d-grid">
                <button  className="mt-3 btn btn-xl btn-outline-success">Volver</button>
              </NavLink>
              <div className="my-4 d-flex pb-3">
                <NavLink to="/recuperar-contrasena" className="small text-gray-600 ms-auto mt-1">¿Olvidaste tu contraseña?</NavLink>
              </div>
              <div className="border-top border-gray-200 pt-4">
                <span className="text-gray-700">¿No tenés cuenta? <NavLink to={`/registrate${referrer ? `?ref=${referrer}` : ''}`} className="link-primary">Registrate</NavLink></span>
              </div>
            </div>
            <div className="position-absolute py-3">
              <small className="text-gray-600 mb-2">Desarrollado por <a href="https://www.reachout.global/" target="_blank" rel="noreferrer" className="text-black fw-bold">ReachOut</a> &mdash; Versión {process.env.REACT_APP_VERSION}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth.isAuthenticated,
  assets: state.assets,
});

export default connect(mapStateToProps)(LoginOTP);
